import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderCheckboxType = "checkbox";
export type TFormBuilderCheckboxRole = "custom";

export interface IFormBuilderCheckboxSettings {
  label: string;
}

export interface IFormBuilderCheckboxData extends IFormBuilderItemDataBase {
  type: TFormBuilderCheckboxType;
  role: TFormBuilderCheckboxRole;
  settings: IFormBuilderCheckboxSettings;
}

export interface IFormBuilderCheckbox extends IFormBuilderItemBase {
  data: IFormBuilderCheckboxData;
}

export type TFormBuilderCheckboxSettings = IFormBuilderCheckbox["data"]["settings"];

export function isFormBuilderCheckboxItem(item: TFormBuilderItem): item is IFormBuilderCheckbox {
  return item.data.type === "checkbox";
}

export function isFormBuilderCheckboxType(value: string): value is TFormBuilderCheckboxType {
  return value === "checkbox";
}

export function isFormBuilderCheckboxRole(value: string): value is TFormBuilderCheckboxRole {
  return value === "custom";
}

export function formBuilderGenerateDefaultCustomCheckbox(): IFormBuilderCheckbox {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "checkbox",
      role: "custom",
      settings: {
        label: "Checkbox", // TODO: Translation
      },
    },
  };
}